import type { Group, GroupBackgroundStyleVariant, GroupSettings } from '@gik/core/models/gik/Group';
import { iconImageUrl, logoImageUrl } from '@gik/inkind-page/constants';
import React from 'react';

export function useGroupDefaults(group: Group): Group {
  return React.useMemo(() => {
    if (!group) return null;
    const newGroup = { ...group };

    if (!group.inkindGroupSettings?.brandColor) {
      newGroup.inkindGroupSettings = {
        ...(newGroup.inkindGroupSettings ?? {}),
        brandColor: '#FF9E5A',
        styleVariant: 'solid' as GroupBackgroundStyleVariant,
      } as GroupSettings;
    }

    if (!group.inkindGroupSettings?.gradientColor1) {
      newGroup.inkindGroupSettings = {
        ...(newGroup.inkindGroupSettings ?? {}),
        gradientColor1: '#E9582B',
      } as GroupSettings;
    }

    if (!group.inkindGroupSettings?.gradientColor2) {
      newGroup.inkindGroupSettings = {
        ...(newGroup.inkindGroupSettings ?? {}),
        gradientColor2: '#FFD76F',
      } as GroupSettings;
    }

    if (!group.inkindGroupSettings?.iconImageUrl) {
      newGroup.inkindGroupSettings = {
        ...(newGroup.inkindGroupSettings ?? {}),
        iconImageUrl: iconImageUrl,
      } as GroupSettings;
    }

    if (!group.inkindGroupSettings?.logoImageUrl) {
      newGroup.inkindGroupSettings = {
        ...(newGroup.inkindGroupSettings ?? {}),
        logoImageUrl: logoImageUrl,
      } as GroupSettings;
    }

    return newGroup;
  }, [group]);
}
